module.exports = __webpack_public_path__ + "static/yanfei-0e6f73cca61276db2f31252603cf6bc5.png";